import { BillingChangeRequestState } from "./types";

export const defaultState = (): BillingChangeRequestState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    billingChangeRequests: [],
    links: {}
  };
};

export const state = defaultState();
